(() => {
  if (window.__ZEYDRT_CART_DRAWER__) return;
  window.__ZEYDRT_CART_DRAWER__ = '2026-07-31-1';

  const PANEL_SELECTOR = '.double-header__panel[data-header-panel="cart"]';
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let refreshTimer = 0;
  let activeCart = null;

  const escapeHtml = (value) => String(value == null ? '' : value)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#039;');

  const formatMoney = (cents, currency) => {
    const value = Number(cents || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' &&
        (window.Shopify.money_format || (window.theme && window.theme.moneyFormat))) {
      return window.Shopify.formatMoney(value, window.Shopify.money_format || window.theme.moneyFormat);
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      }).format(value / 100);
    } catch (error) {
      return '$' + (value / 100).toFixed(2);
    }
  };

  const getItemImage = (item) => {
    const image = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
    if (!image) return '';
    return String(image).replace(/(\.(?:jpe?g|png|webp))(?:\?.*)?$/i, '_240x$1');
  };

  const getVariantText = (item) => {
    if (Array.isArray(item.options_with_values) && item.options_with_values.length) {
      return item.options_with_values
        .filter((option) => option && option.value && option.value !== 'Default Title')
        .map((option) => {
          const name = String(option.name || '');
          const separator = /^size\b/i.test(name) ? ':\n' : ': ';
          return name + separator + option.value;
        }).join('\n');
    }
    if (Array.isArray(item.variant_options)) {
      return item.variant_options.filter((value) => value && value !== 'Default Title').join('\n');
    }
    return item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
  };

  const updateHeaderCount = (count) => {
    const quantity = Number(count || 0);
    document.querySelectorAll('[data-header-open="cart"]').forEach((button) => {
      const label = button.querySelector('.double-header__action-label');
      if (label) label.textContent = quantity > 0 ? 'Cart ' + quantity : 'Cart';
      const isMobile = button.classList.contains('double-header__mobile-button');
      const selector = isMobile ? '.double-header__mobile-cart-count' : '.double-header__cart-badge';
      let badge = button.querySelector(selector);
      if (quantity > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = selector.slice(1);
          button.appendChild(badge);
        }
        badge.textContent = quantity;
        badge.hidden = false;
      } else if (badge) {
        badge.textContent = '';
        badge.hidden = true;
      }
    });
    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = quantity;
      element.hidden = quantity === 0;
    });
  };

  const itemMarkup = (item, cart) => {
    const title = item.product_title || item.title || '';
    const image = getItemImage(item);
    const imageAlt = (item.featured_image && item.featured_image.alt) || title;
    const variant = getVariantText(item);
    const finalPrice = Number(item.final_price != null ? item.final_price : (item.discounted_price != null ? item.discounted_price : item.price || 0));
    const originalPrice = Number(item.original_price != null ? item.original_price : finalPrice);
    const compareMarkup = originalPrice > finalPrice ? '<s class="zy-cart-drawer__compare">' + escapeHtml(formatMoney(originalPrice, cart.currency)) + '</s>' : '';
    const imageMarkup = image
      ? '<img class="zy-cart-drawer__image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(imageAlt) + '" loading="lazy" width="240" height="240">'
      : '<span class="zy-cart-drawer__image zy-cart-drawer__image--empty"></span>';
    return '<article class="zy-cart-drawer__item" data-line-key="' + escapeHtml(item.key) + '">' +
      '<a class="zy-cart-drawer__image-link" href="' + escapeHtml(item.url || '#') + '">' + imageMarkup + '</a>' +
      '<div class="zy-cart-drawer__details">' +
        '<a class="zy-cart-drawer__title" href="' + escapeHtml(item.url || '#') + '">' + escapeHtml(title) + '</a>' +
        '<div class="zy-cart-drawer__price-row"><span class="zy-cart-drawer__price">' + escapeHtml(formatMoney(finalPrice, cart.currency)) + '</span>' + compareMarkup + '</div>' +
        (variant ? '<p class="zy-cart-drawer__variant">' + escapeHtml(variant) + '</p>' : '') +
        '<div class="zy-cart-drawer__actions">' +
          '<div class="zy-cart-drawer__quantity" aria-label="Quantity">' +
            '<button type="button" data-zy-cart-action="decrease" data-line-key="' + escapeHtml(item.key) + '" aria-label="Decrease quantity">−</button>' +
            '<output aria-live="polite">' + Number(item.quantity || 0) + '</output>' +
            '<button type="button" data-zy-cart-action="increase" data-line-key="' + escapeHtml(item.key) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button class="zy-cart-drawer__remove" type="button" data-zy-cart-action="remove" data-line-key="' + escapeHtml(item.key) + '">Remove</button>' +
        '</div>' +
      '</div>' +
    '</article>';
  };

  const drawerMarkup = (cart) => {
    if (!cart.items || cart.items.length === 0) {
      return '<div class="zy-cart-drawer"><div class="zy-cart-drawer__empty">' +
        '<h3 class="zy-cart-drawer__empty-title">Your cart is empty</h3><p class="zy-cart-drawer__empty-text">Add a painting you love and it will appear here.</p>' +
        '<a class="zy-cart-drawer__continue" href="' + escapeHtml(ROOT + 'collections/all') + '">Continue shopping</a>' +
      '</div></div>';
    }
    const noteValue = typeof cart.note === 'string' ? cart.note.trim() : '';
    const noteLabel = noteValue ? 'Edit order note' : 'Add order note';
    const notePreview = noteValue
      ? '<div class="zy-cart-drawer__note-preview"><span>Order note</span><p>' + escapeHtml(noteValue) + '</p></div>'
      : '';

    return '<div class="zy-cart-drawer">' +
      '<div class="zy-cart-drawer__scroll"><div class="zy-cart-drawer__items">' +
        cart.items.map((item) => itemMarkup(item, cart)).join('') +
      '</div></div>' +
      '<div class="zy-cart-drawer__footer">' +
        '<button class="zy-cart-drawer__note-toggle" type="button" data-zy-cart-action="toggle-note" aria-expanded="false">' +
          '<span>' + noteLabel + '</span><span aria-hidden="true">+</span>' +
        '</button>' +
        notePreview +
        '<div class="zy-cart-drawer__note" hidden>' +
          '<label for="ZeydrtCartNote">Order note</label>' +
          '<textarea id="ZeydrtCartNote" rows="3">' + escapeHtml(cart.note || '') + '</textarea>' +
          '<button class="zy-cart-drawer__note-save" type="button" data-zy-cart-action="save-note">Save note</button>' +
        '</div>' +
        '<form class="zy-cart-drawer__checkout-form" action="' + escapeHtml(ROOT + 'cart') + '" method="post">' +
          '<button class="zy-cart-drawer__checkout" type="submit" name="checkout">' +
            '<span>CHECKOUT</span><span aria-hidden="true">·</span><span>' + escapeHtml(formatMoney(cart.total_price, cart.currency)) + '</span>' +
          '</button>' +
        '</form>' +
      '</div>' +
    '</div>';
  };

  const getPanel = () => document.querySelector(PANEL_SELECTOR);

  const render = (cart) => {
    const panel = getPanel();
    if (!panel || !cart) return;
    activeCart = cart;
    panel.classList.add('zy-cart-panel');
    const head = panel.querySelector('.double-header__panel-head');
    const title = head && head.querySelector('.double-header__panel-title');
    if (title) title.textContent = cart.item_count > 0 ? 'Cart ' + cart.item_count : 'Cart';
    Array.from(panel.children).forEach((child) => { if (child !== head) child.remove(); });
    panel.insertAdjacentHTML('beforeend', drawerMarkup(cart));
    updateHeaderCount(cart.item_count);
  };

  const showError = (message) => {
    const panel = getPanel();
    if (!panel) return;
    let error = panel.querySelector('.zy-cart-drawer__error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'zy-cart-drawer__error';
      const drawer = panel.querySelector('.zy-cart-drawer');
      panel.insertBefore(error, drawer || null);
    }
    error.textContent = message || 'Could not update the cart. Please try again.';
  };

  const request = async (endpoint, options) => {
    const response = await fetch(ROOT + endpoint, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      ...options
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Cart request failed');
    return data;
  };

  const refresh = async () => {
    const panel = getPanel();
    if (!panel) return;
    panel.classList.add('zy-cart-panel', 'is-loading');
    try {
      render(await request('cart.js', { method: 'GET' }));
    } catch (error) {
      console.error('[Zeydrt cart drawer]', error);
      showError(error.message);
    } finally {
      panel.classList.remove('is-loading');
    }
  };

  const scheduleRefresh = (delay = 30) => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, delay);
  };

  const changeQuantity = async (key, quantity) => {
    const panel = getPanel();
    if (!panel) return;
    panel.classList.add('is-loading');
    try {
      const cart = await request('cart/change.js', {
        method: 'POST', body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity || 0)) })
      });
      render(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'zeydrt-cart-drawer' } }));
    } catch (error) {
      console.error('[Zeydrt cart drawer]', error);
      showError(error.message);
    } finally {
      const currentPanel = getPanel();
      if (currentPanel) currentPanel.classList.remove('is-loading');
    }
  };

  const saveNote = async (note) => {
    const panel = getPanel();
    if (!panel) return;
    panel.classList.add('is-loading');
    try {
      render(await request('cart/update.js', { method: 'POST', body: JSON.stringify({ note }) }));
    } catch (error) {
      console.error('[Zeydrt cart drawer]', error);
      showError(error.message);
    } finally {
      const currentPanel = getPanel();
      if (currentPanel) currentPanel.classList.remove('is-loading');
    }
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-header-open="cart"]');
    if (opener) { scheduleRefresh(0); return; }
    const actionButton = event.target.closest('[data-zy-cart-action]');
    if (!actionButton || !actionButton.closest(PANEL_SELECTOR)) return;
    const action = actionButton.dataset.zyCartAction;
    const key = actionButton.dataset.lineKey;
    if (action === 'toggle-note') {
      const footer = actionButton.closest('.zy-cart-drawer__footer');
      const note = footer.querySelector('.zy-cart-drawer__note');
      const preview = footer.querySelector('.zy-cart-drawer__note-preview');
      const isHidden = note.hidden;
      note.hidden = !isHidden;
      if (preview) preview.hidden = isHidden;
      actionButton.setAttribute('aria-expanded', String(isHidden));
      actionButton.querySelector('[aria-hidden="true"]').textContent = isHidden ? '−' : '+';
      if (isHidden) note.querySelector('textarea').focus();
      return;
    }
    if (action === 'save-note') {
      saveNote(actionButton.closest('.zy-cart-drawer__note').querySelector('textarea').value);
      return;
    }
    if (!key || !activeCart) return;
    const item = activeCart.items.find((cartItem) => cartItem.key === key);
    if (!item) return;
    if (action === 'increase') changeQuantity(key, item.quantity + 1);
    if (action === 'decrease') changeQuantity(key, Math.max(0, item.quantity - 1));
    if (action === 'remove') changeQuantity(key, 0);
  });

  document.addEventListener('cart:updated', (event) => {
    if (event.detail && event.detail.source === 'zeydrt-cart-drawer') return;
    if (event.detail && event.detail.cart && Array.isArray(event.detail.cart.items)) render(event.detail.cart);
    else scheduleRefresh();
  });
  document.addEventListener('cart:refresh', () => scheduleRefresh());
  document.addEventListener('shopify:cart:lines-update', () => scheduleRefresh());

  const observer = new MutationObserver((mutations) => {
    const panelWasAdded = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) =>
      node.nodeType === 1 && (node.matches(PANEL_SELECTOR) || node.querySelector(PANEL_SELECTOR))
    ));
    if (panelWasAdded) scheduleRefresh();
  });

  const init = () => {
    observer.observe(document.body, { childList: true, subtree: true });
    scheduleRefresh(0);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
